export const environment = {
  production: false,
  apiBaseUrl: 'https://mitrex-global.azurewebsites.net' // your dev base URL
};
